import { NgModule } from '@angular/core';
import { BytesConvert } from '@app/shared/pipes/bytes-converter.pipe';
import { DropdownFilterActivePipe } from '@app/shared/pipes/dropdown-filter-active.pipe';
import { DecimalSeparatorPipe } from '@app/shared/pipes/decimal-separator.pipe';
import { MomentDatePipe } from '@app/shared/pipes/moment-date.pipe';
import { SafeHtmlPipe } from '@app/shared/pipes/safe-html.pipe';
import { SearchPipe } from '@app/shared/pipes/search-filter.pipe';
import { GetTopicFieldValuePipe } from './get-topic-field-value.pipe';
import { IconGetClassPipe, IconGetColorPipe } from './icons.pipe';
import { DynamicPipe } from './dynamic-pipes.pipe';
import { FnPipe } from './fn.pipe';
import { StringFormatPipe } from './string-format.pipe';
import { FAIconClassPipe } from './fa-icon-class.pipe';
import { NoValuePipe } from './no-value.pipe';
import { MemoizePipe } from './memoize.pipe';
import { ToKendoDateFormatPipe } from './to-kendo-date-format.pipe';
import { PxToRemPipe } from './px-to-rem.pipe';

const pipes = [
  BytesConvert,
  DecimalSeparatorPipe,
  DropdownFilterActivePipe,
  SafeHtmlPipe,
  MomentDatePipe,
  SearchPipe,
  GetTopicFieldValuePipe,
  IconGetClassPipe,
  IconGetColorPipe,
  DynamicPipe,
  FnPipe,
  StringFormatPipe,
  FAIconClassPipe,
  NoValuePipe,
  MemoizePipe,
  ToKendoDateFormatPipe,
  PxToRemPipe,
];
@NgModule({
  imports: pipes,
  providers: [GetTopicFieldValuePipe, MomentDatePipe],
  exports: pipes,
})
export class PipesModule {}
